import { render, staticRenderFns } from "./LogoAndText.vue?vue&type=template&id=5df82eb8"
import script from "./LogoAndText.vue?vue&type=script&lang=js"
export * from "./LogoAndText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports